<template>
  <div
    class="c-serviceBlockItem"
    :class="`c-serviceBlockItem${layoutType}`"
  >
    <div
      class="c-serviceBlockItem_inner c-serviceBlockItemRow"
      :class="`c-serviceBlockItem${layoutType}_inner`"
    >
      <div class="c-serviceBlockItemRow_image">
        <service-image-slide
          class="c-serviceBlockItemImage"
          :service-id="service.service.id"
          :service-image="service.service.serviceImagesList"
          :service-movie="service.service.serviceMoviesList"
          :movie-priority-flag="Number(service.service.moviePriorityFlag)"
          :layout-type="layoutType"
          padding-type="ratio"
          :padding-ratio="IMAGE_HEIGHT_RATIO"
          :url-ref="urlRef"
          :is-loading="isLoading"
          :disabled-lazy-load="itemIndex < IMMEDIATE_LOAD_COUNT"
        />

        <div
          v-if="isLoggedIn && (isPC || isTB || isSP)"
          class="c-serviceBlockItemRow_favButton"
        >
          <fav-button-v2
            :is-favorited="service.service.isFavorited"
            :service-id="service.service.id"
            :is-always-show="false"
          />
        </div>

        <div class="c-serviceBlockItemRow_labels">
          <div
            class="c-serviceBlockItemRowLabel c-serviceBlockItemRowLabel-standby"
            v-if="service.service.serviceClass === SERVICE_CLASS_PHONE && service.provider.phoneWait"
          >
            <div class="c-serviceBlockItemRowLabel_label">今すぐ相談可能</div>
          </div>
          <div
            class="c-serviceBlockItemRowLabel c-serviceBlockItemRowLabel-busy"
            v-if="service.service.serviceClass === SERVICE_CLASS_PHONE && service.provider.phoneTalking"
          >
            <div class="c-serviceBlockItemRowLabel_label">相談中</div>
          </div>
          <div
            class="c-serviceBlockItemRowLabel c-serviceBlockItemRowLabel-away"
            v-if="service.service.serviceClass === SERVICE_CLASS_PHONE && service.provider.isProviderAway"
          >
            <div class="c-serviceBlockItemRowLabel_label">離席中</div>
          </div>
          <div
            class="c-serviceBlockItemRowLabel c-serviceBlockItemRowLabel-reserve"
            v-if="service.service.serviceClass === SERVICE_CLASS_PHONE && service.service.reservationAvailableFlag"
          >
            <div class="c-serviceBlockItemRowLabel_label">予約受付中</div>
          </div>
          <div
            class="c-serviceBlockItemRowLabel c-serviceBlockItemRowLabel-limit"
            v-if="service.service.fullCorrespondenceFlag"
          >
            <div class="c-serviceBlockItemRowLabel_label">満枠対応中</div>
          </div>
          <div
            class="c-serviceBlockItemRowLabel c-serviceBlockItemRowLabel-stop"
            v-if="service.service.stopFg"
          >
            <div class="c-serviceBlockItemRowLabel_label">受付休止中</div>
          </div>
        </div>
      </div>

      <div
        class="c-serviceBlockItemRow_certificationIcon"
        v-if="service.service.proServiceFlag"
      >
        <ProIcon
          is-outlined
          :width="isPC ? '32px' : '30px'"
        />
      </div>
      <div
        class="c-serviceBlockItemRow_certificationIcon"
        v-else-if="service.service.certificationDivinationServiceFlag"
      >
        <DivinationIcon
          is-outlined
          :width="isPC ? '32px' : '30px'"
        />
      </div>

      <div class="c-serviceBlockItemRow_flag">
        <img
          src="@/assets/images/common/icon-video-service.svg"
          alt=""
          loading="lazy"
          decoding="async"
          v-if="service.service.videoType === VIDEO_TYPE"
        />
        <img
          src="@/assets/images/common/icon-phone-service.svg"
          alt=""
          loading="lazy"
          decoding="async"
          v-if="service.service.serviceClass === SERVICE_CLASS_PHONE"
        />
      </div>

      <div class="c-serviceBlockItemRow_content c-serviceBlockItemContent">
        <div class="c-serviceBlockItemContent_header c-serviceBlockItemContentHeader">
          <div class="c-serviceBlockItemContent_title">
            <div class="c-serviceBlockItemContent_nameWrapper">
              <span
                v-if="isServicePr"
                class="c-serviceBlockItemContent_servicePrLabel"
              >PR</span>
              <h3 class="c-serviceBlockItemContent_name">{{ serviceName }}</h3>
              <DLabel
                class="c-serviceBlockItemContent_customizeRequired"
                v-if="service.service.customizeRequiredFlag  && isPC"
                text-color="Gray900"
                background-color="Gray25"
                border-color="Gray25"
                rounded
              >見積り必須</DLabel>
            </div>
          </div>
        </div>

        <div class="c-serviceBlockItemContent_footer c-serviceBlockItemContentFooter">
          <div class="c-serviceBlockItemContent_infoUser c-serviceBlockItemContentInfoUser">
            <div
              v-if="service.provider.level > 0"
              class="c-serviceBlockItemContentInfoUser_level"
            >
              <img
                :src="$coconala.levelIconURL(service.provider.level)"
                alt=""
                loading="lazy"
                decoding="async"
              >
            </div>
            <div class="c-serviceBlockItemContentInfoUser_name">
              <span>{{ service.provider.name }}</span>
            </div>
          </div>

          <div class="c-serviceBlockItemContent_price c-serviceBlockItemContentPrice">
            <div class="c-serviceBlockItemContentPrice_rating">
              <span class="c-serviceBlockItemContentPriceRating">
                <coconala-icon
                  name="star"
                  class="c-serviceBlockItemContentPriceRating_star"
                />
                <span
                  class="c-serviceBlockItemContentPriceRating_score"
                  v-if="service.service.ratings.indicator"
                >
                  {{ service.service.ratings.indicator.toFixed(1) }}
                </span>
                <span
                  class="c-serviceBlockItemContentPriceRating_noScore"
                  v-else
                >
                  -
                </span>
              </span>
              <span
                class="c-serviceBlockItemContentPriceRating_count"
                v-if="service.service.performanceCount > 0"
              >({{ service.service.performanceCount }})
              </span>
            </div>

            <div class="c-serviceBlockItemContentPrice_price">
              <div v-if="service.service.serviceClass === SERVICE_CLASS_PHONE">
                <strong>{{ $util.numberWithDelimiter(service.service.priceWot) }}</strong>円<span class="c-serviceBlockItemContentPrice_unit">/分</span>
              </div>
              <div v-else-if="service.service.unitTime">
                <strong>{{ $util.numberWithDelimiter(service.service.priceWot) }}</strong>円<span class="c-serviceBlockItemContentPrice_unit">/{{ $util.numberWithDelimiter(service.service.unitTime) }}分</span>
              </div>
              <div v-else>
                <strong>{{ $util.numberWithDelimiter(service.service.priceWot) }}</strong>円
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ServiceImageSlide from '~/components/molecules/ServiceImageSlide'
import FavButtonV2 from '~/components/molecules/buttons/FavButtonV2'
import ProIcon from '~/components/molecules/ProIcon'
import DLabel from '~/components/atoms/DS2/DLabel'
import DivinationIcon from '~/components/molecules/Divination'
import { mapGetters } from 'vuex'

const SERVICE_CLASS_PHONE = 1
const VIDEO_TYPE = 2
/** 画像領域の高さ比率 */
const IMAGE_HEIGHT_RATIO = (100 * 19) / 23
/** 即時ロードする画像数 */
const IMMEDIATE_LOAD_COUNT = 8
// 見積り必須時のタイトル最大文字数
const MAX_TITLE_FOR_CUSTOMIZE_REQUIRED = 23
// サービスPRかつ見積り必須時のタイトル最大文字数
const MAX_TITLE_FOR_CUSTOMIZE_REQUIRED_SERVICE_PR = 20

export default {
  name: 'ServiceBlockItemV2',
  components: {
    ServiceImageSlide,
    FavButtonV2,
    ProIcon,
    DLabel,
    DivinationIcon
  },
  props: {
    itemIndex: {
      type: Number,
      default: 0
    },
    service: {
      type: Object
    },
    condition: {
      type: Object,
      default() {
        return {}
      }
    },
    layoutType: {
      type: String,
      default: 'Block'
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    urlRef: {
      type: Object
    },
    isServicePr: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      SERVICE_CLASS_PHONE,
      VIDEO_TYPE,
      disabledLinkEffect: true,
      IMAGE_HEIGHT_RATIO,
      IMMEDIATE_LOAD_COUNT
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('ui', ['isPC', 'isTB', 'isSP']),
    truncateLength() {
      return this.isServicePr
        ? MAX_TITLE_FOR_CUSTOMIZE_REQUIRED_SERVICE_PR
        : MAX_TITLE_FOR_CUSTOMIZE_REQUIRED
    },
    serviceName() {
      let serviceName = this.service.service.name
      if (this.service.service.overview) {
        serviceName = this.service.service.overview
      }
      // 見積り必須フラグを表示する場合は、truncateする
      return this.service.service.customizeRequiredFlag && this.isPC
        ? this.$util.truncate(serviceName, this.truncateLength)
        : serviceName
    }
  }
}
</script>
<style lang="scss" scoped>
.c-serviceBlockItemBlock {
  position: relative;
  background-color: $color-white;
  color: $color-gray-900;

  /deep/ .c-favButton {
    width: 32px;
    height: 32px;

    & > i {
      font-size: 32px;
    }
  }

  &_inner {
    position: relative;
    margin-bottom: 16px;
    border: 1px solid $ds2-color-gray-50;
    border-radius: 4px;

    &:hover {
      /deep/ .c-favButtonWrapper {
        display: block;
      }
    }
  }

  /deep/ .c-staticImage_thumbnailImage {
    height: 188px;
    border-radius: 4px 4px 0 0;
  }

  a {
    @include link-effect;
  }
}

.c-serviceBlockItemRow {
  &_image {
    position: relative;
    width: 228px;
    height: 188px;
  }

  &_certificationIcon {
    position: absolute;
    top: -3px;
    left: 10px;
    z-index: z(dropdown, content);
  }

  &_favButton {
    position: absolute;
    right: 8px;
    bottom: 8px;
  }

  &_labels {
    position: absolute;
    bottom: 0;
    left: -1px;
    z-index: 10;
    width: 100%;
  }

  &_flag {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    width: 36px;
    height: 36px;

    img {
      width: 36px;
      height: 36px;
      border-top-right-radius: 3px;
    }
  }

  &_content {
    position: relative;
    padding: 8px 10px;
  }
}

.c-serviceBlockItemImage {
  position: relative;
  width: 100%;
  height: 100%;
}

.c-serviceBlockItemContent {
  &_title {
    @include link-effect;

    overflow: hidden;
    height: 3em;
    color: $ds2-color-gray-900;
    font-weight: normal;
    font-size: 14px;
    line-height: 1.5;
  }

  &_nameWrapper {
    position: relative;
    display: -webkit-box;
    margin-bottom: 20px;
    width: 100%;
    height: 3em;
  }

  &_name {
    @include line-clamp(2, 1.5em);

    display: unset !important;
  }

  &_servicePrLabel {
    font-size: 10px;
    line-height: 1;
    color: $ds2-color-gray-600;
    padding: 1px 4px;
    border: 1px solid $ds2-color-gray-200;
    border-radius: 2px;
    margin-right: 4px;
    position: relative;
    bottom: 1px;
  }

  &_customizeRequired {
    position: absolute;
    top: 2em;
    right: 0;
    display: inline-flex;
    margin-left: 4px;
    padding: 3px 8px;
    min-width: 70px;
    font-size: 10px;

    align-items: center;
    justify-content: center;
  }
}

.c-serviceBlockItemContentInfoUser {
  position: relative;
  z-index: 10;
  display: flex;
  margin-top: 8px;
  height: 24px;

  align-items: center;

  &_icon {
    overflow: hidden;
    margin-right: 4px;
    width: 24px;
    height: 24px;

    flex-basis: 24px;

    img {
      width: 20px;
      height: 20px;
      border-radius: 50%;
    }
  }

  &_name {
    display: inline-flex;
    align-items: center;
    span {
      @include link-effect;

      display: inline-block;
      overflow: hidden;
      max-width: 140px;
      height: 20px;
      color: $ds2-color-gray-700;
      vertical-align: middle;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 11px;
    }
  }

  &_level {
    position: relative;
    margin-right: 4px;
    display: inline-flex;
    align-items: center;

    img {
      width: 22px;
    }
  }
}

.c-serviceBlockItemRowLabel {
  display: flex;
  box-sizing: border-box;
  margin-left: 1px;
  width: 100%;
  height: 21px;

  align-items: center;
  justify-content: center;

  &-standby {
    background: $ds2-color-coconala-orange;
    color: $color-white;
  }

  &-busy {
    background: $ds2-color-brand-secondary;
    color: $color-white;
  }

  &-away {
    background: $ds2-color-gray-100;
    color: $ds2-color-gray-700;
  }

  &-reserve {
    border: solid 1px $ds2-color-coconala-orange;
    background: $color-white;
    color: $ds2-color-coconala-orange;
  }

  &-limit {
    background: $ds2-color-red;
    color: $color-white;
  }

  &-stop {
    background: $ds2-color-gray-100;
    color: $ds2-color-gray-700;
  }

  &_label {
    letter-spacing: 1px;
    font-weight: bold;
    font-size: 11px;
    line-height: 11px;
  }
}

.c-serviceBlockItemContentPrice {
  position: relative;
  z-index: 10;
  display: flex;
  margin-top: 8px;

  justify-content: space-between;

  &_rating {
    display: flex;

    align-items: center;
  }

  &_price {
    color: $ds2-color-gray-900;
    font-size: 12px;

    strong {
      padding-right: 2px;
      font-weight: bold;
      font-size: 17px;
    }
  }
}

.c-serviceBlockItemContentPriceRating {
  display: inline-block;
  font-size: 13px;
  line-height: 1;

  &_star {
    color: $ds2-color-orange;
    vertical-align: -1px;
    font-size: 13px;
  }

  &_score {
    color: $ds2-color-orange;
    font-weight: bold;
    font-size: 13px;
  }

  &_noScore {
    margin-right: 2px;
    font-size: 13px;
  }

  &_count {
    margin-left: 2px;
    color: $ds2-color-gray-900;
    letter-spacing: 0.05em;
    font-size: 11px;
  }
}

@media (min-width: breakpoint(Search, M) + 1) {
  .c-serviceBlockItemBlock {
    width: 230px;

    flex-basis: 230px;
  }
}

@media (max-width: breakpoint(Search, M)) {
  .c-serviceBlockItemBlock {
    width: auto;
    border-radius: 4px;

    flex-basis: 100%;

    /deep/ .c-staticImage_thumbnailImage {
      height: unset;
      border-radius: 3px 3px 0 0;
    }
  }

  .c-serviceBlockItemRow {
    &_image {
      position: relative;
      min-height: 121px;
      width: 100%;
      height: inherit;
    }

    &_certificationIcon {
      position: absolute;
      top: -1px;
      left: 8px;
      z-index: 2;
    }

    &_labels {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
    }

    &_content {
      position: relative;
      padding: 4px 8px;
    }
  }

  .c-serviceBlockItemImage {
    img {
      width: 100%;
      height: auto;
    }
  }

  .c-serviceBlockItemContent {
    &_title {
      overflow: hidden;
      // SPでは2行表示させたいため1.5(line-height分) x 2
      height: 3em;
      font-weight: normal;
      font-size: 12px;

      p {
        margin-bottom: 0;
      }
    }
    &_servicePrLabel {
      font-size: 10px;
    }
  }

  .c-serviceBlockItemContentInfoUser {
    display: inline-flex;
    overflow: hidden;
    margin-top: 6px;

    justify-content: left;

    &_icon {
      display: none;
    }

    &_name {
      span {
        max-width: 80px;
        height: unset;
        font-size: 10px;
      }
    }

    &_level {
      position: relative;
      margin-right: 4px;
      height: 20px;

      img {
        width: 20px;
      }
    }
  }

  .c-serviceBlockItemRowLabel {
    margin-left: 0;
    height: 16px;

    &_label {
      font-size: 11px;
      line-height: 12px;
    }
  }

  .c-serviceBlockItemContentPrice {
    &_rating {
      padding-top: 0;
      text-align: left;
    }

    &_price {
      flex: 2;
      text-align: right;
      font-size: 12px;

      strong {
        font-size: 14px;
      }
    }

    &_unit {
      display: inline-block;
    }
  }

  .c-serviceBlockItemContentPriceRating {
    padding-top: 0;
    height: 21px;
    font-size: 12px;
    line-height: inherit;

    &_count {
      margin-top: 1px;
      height: 21px;
      font-size: 12px;
    }
  }
}

@media (min-width: breakpoint(Search, S) + 1) and (max-width: breakpoint(Search, M)) {
  .c-serviceBlockItemBlock {
    &_inner {
      &:hover {
        opacity: 1;
      }
    }
  }
}
</style>
